module.exports = __webpack_public_path__ + "static/media/arrow-right-black.5bc4f561.svg";